// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import { UserPlus, ArrowRight, Users, Briefcase, Award } from 'lucide-react';

// const RegisterAsJobSeeker = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-indigo-950 via-purple-950 to-black flex items-center justify-center p-6 overflow-hidden relative">
//       {/* Background Decorative Elements */}
//       <div className="absolute inset-0 overflow-hidden">
//         <div className="absolute top-20 -left-20 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl"></div>
//         <div className="absolute bottom-20 -right-20 w-96 h-96 bg-indigo-500/10 rounded-full blur-3xl"></div>
//         <div className="absolute top-1/2 left-1/3 w-64 h-64 bg-orange-500/5 rounded-full blur-3xl"></div>
//       </div>

//       <div className="max-w-4xl w-full">
//         <motion.div
//           initial={{ opacity: 0, y: 40 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8, ease: "easeOut" }}
//           className="relative bg-gray-900/70 backdrop-blur-2xl border border-white/10 rounded-3xl shadow-2xl overflow-hidden"
//         >
//           {/* Top Gradient Bar */}
//           <div className="h-2 bg-gradient-to-r from-orange-500 via-purple-500 to-indigo-500"></div>

//           <div className="p-12 md:p-16">
//             <div className="flex flex-col items-center text-center mb-12">
//               <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-orange-500 to-purple-600 rounded-2xl mb-6 shadow-lg">
//                 <UserPlus className="w-10 h-10 text-white" />
//               </div>

//               <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-white via-orange-200 to-purple-200 bg-clip-text text-transparent mb-4">
//                 Ready to Get Hired?
//               </h1>
              
//               <p className="text-xl text-gray-400 max-w-lg">
//                 Join thousands of job seekers finding opportunities across Nigeria
//               </p>
//             </div>

//             {/* Features */}
//             <div className="grid md:grid-cols-3 gap-6 mb-12">
//               {[
//                 {
//                   icon: <Users className="w-8 h-8" />,
//                   title: "Find Jobs Fast",
//                   desc: "Access thousands of verified job opportunities near you"
//                 },
//                 {
//                   icon: <Briefcase className="w-8 h-8" />,
//                   title: "Showcase Skills",
//                   desc: "Build a professional profile that stands out to employers"
//                 },
//                 {
//                   icon: <Award className="w-8 h-8" />,
//                   title: "Get Hired",
//                   desc: "Connect directly with employers and start earning"
//                 }
//               ].map((feature, index) => (
//                 <motion.div
//                   key={index}
//                   whileHover={{ y: -8 }}
//                   className="bg-gray-800/50 border border-white/5 rounded-2xl p-8 hover:border-orange-500/30 transition-all group"
//                 >
//                   <div className="text-orange-400 mb-6 group-hover:scale-110 transition-transform">
//                     {feature.icon}
//                   </div>
//                   <h3 className="text-2xl font-semibold text-white mb-3">{feature.title}</h3>
//                   <p className="text-gray-400 leading-relaxed">{feature.desc}</p>
//                 </motion.div>
//               ))}
//             </div>

//             {/* Call to Action */}
//             <div className="text-center">
//               <p className="text-gray-400 text-lg mb-8">
//                 Click below to register as a <span className="text-orange-400 font-semibold">Job Seeker</span>
//               </p>

//               <motion.button
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.98 }}
//                 onClick={() => navigate('/signup')}
//                 className="group relative inline-flex items-center gap-4 bg-gradient-to-r from-orange-500 to-purple-600 hover:from-orange-600 hover:to-purple-700 text-white font-semibold text-xl px-14 py-6 rounded-2xl shadow-xl shadow-orange-500/30 transition-all duration-300 overflow-hidden"
//               >
//                 <span>Click to Register as a Job Seeker</span>
//                 <ArrowRight className="w-7 h-7 group-hover:translate-x-2 transition-transform" />
                
//                 {/* Shine Effect */}
//                 <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
//               </motion.button>

//               <p className="mt-8 text-sm text-gray-500">
//                 Already have an account?{' '}
//                 <button 
//                   onClick={() => navigate('/signin')}
//                   className="text-orange-400 hover:text-orange-300 underline underline-offset-4"
//                 >
//                   Sign in here
//                 </button>
//               </p>
//             </div>
//           </div>

//           {/* Bottom Decorative Bar */}
//           <div className="bg-black/40 py-6 text-center text-xs text-gray-500 border-t border-white/10">
//             Join the fastest growing job platform in Nigeria • Trusted by thousands
//           </div>
//         </motion.div>
//       </div>
//     </div>
//   );
// };

// export default RegisterAsJobSeeker;





import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Hammer, Wrench, Wallet } from 'lucide-react';

// Google fonts: a slab display for the "stamped" headline, Inter for body,
// IBM Plex Mono for the ticket number / utility text.
const FontImport = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Zilla+Slab:wght@600;700&family=Inter:wght@400;500;600&family=IBM+Plex+Mono:wght@500&display=swap');
  `}</style>
);

const TICKET = {
  slab: "'Zilla Slab', serif",
  mono: "'IBM Plex Mono', monospace",
};

const lineItems = [
  {
    icon: <Wrench className="w-5 h-5" />,
    title: 'Verified job leads',
    desc: 'See real job vacancies anywhere in Nigeria',
    status: 'LIVE',
  },
  {
    icon: <Hammer className="w-5 h-5" />,
    title: 'Complete your profile',
    desc: 'Update your profile for job employers to know more about you',
    status: 'READY',
  },
  {
    icon: <Wallet className="w-5 h-5" />,
    title: 'Easy Apply',
    desc: 'apply for any job of your chioce and keep your fingers crossed',
    status: 'APPLY',
  },
];

const RegisterAsJobSeeker = () => {
  const navigate = useNavigate();
  const ticketNo = '000482';

  return (
    <div className="min-h-[100dvh] w-full bg-[#F3EEE2] relative flex flex-col items-center justify-center px-4 py-10 sm:py-16">
      <FontImport />

      {/* Decorative ambient layer — isolated so it can never clip page content */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
        <div
          className="absolute inset-0 opacity-[0.35]"
          style={{
            backgroundImage:
              'linear-gradient(#00000008 1px, transparent 1px), linear-gradient(90deg, #00000008 1px, transparent 1px)',
            backgroundSize: '28px 28px',
          }}
        />
        <div className="absolute -top-24 -left-24 w-72 h-72 bg-[#C9502F]/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-24 -right-16 w-80 h-80 bg-[#1F3A5F]/10 rounded-full blur-3xl" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="relative w-full max-w-3xl"
      >
        {/* Punch-hole strip along the top edge of the ticket */}
        <div className="absolute -top-2 left-0 right-0 flex justify-center gap-4 px-8 z-10" aria-hidden="true">
          {Array.from({ length: 14 }).map((_, i) => (
            <span key={i} className="w-3 h-3 rounded-full bg-[#F3EEE2] shrink-0" />
          ))}
        </div>

        <div className="relative bg-[#FBF8F1] border border-[#1F3A5F]/15 rounded-lg shadow-[0_20px_50px_-15px_rgba(31,58,95,0.25)] pt-8 pb-8 sm:pt-10 sm:pb-10 px-6 sm:px-10 md:px-14">
          {/* Ticket header row */}
          <div className="flex flex-wrap items-center justify-between gap-3 pb-6 mb-8 border-b border-dashed border-[#1F3A5F]/25">
            <span
              className="text-[11px] sm:text-xs tracking-[0.25em] text-[#1F3A5F]/70 uppercase"
              style={{ fontFamily: TICKET.mono }}
            >
              Ejobs &middot; Work Order
            </span>
            <span
              className="text-[11px] sm:text-xs tracking-[0.2em] text-[#1F3A5F]/50 uppercase"
              style={{ fontFamily: TICKET.mono }}
            >
              No. {ticketNo}
            </span>
          </div>

          {/* Hero */}
          <div className="mb-10 sm:mb-12">
            <div className="flex flex-wrap items-center gap-3 mb-5">
              <span
                className="inline-flex items-center border-2 border-dashed border-[#C9502F] text-[#C9502F] px-3 py-1 rounded-md text-xs sm:text-sm font-semibold tracking-widest uppercase -rotate-3"
                style={{ fontFamily: TICKET.mono }}
              >
                Open for Work
              </span>
            </div>

            <h1
              className="text-[2.5rem] leading-[1.05] sm:text-6xl md:text-[4.25rem] text-[#1F3A5F] mb-5"
              style={{ fontFamily: TICKET.slab, fontWeight: 700 }}
            >
              Your skill.
              <br />
              Steady work.
            </h1>

            <p className="text-base sm:text-lg text-[#1F3A5F]/70 max-w-xl leading-relaxed">
              Ejobs connects Nigerian jobseekers — artisans, professional and many more to their dream jobs
            </p>
          </div>

          {/* Line items — receipt style */}
          <div className="mb-10 sm:mb-12 divide-y divide-dashed divide-[#1F3A5F]/15">
            {lineItems.map((item, i) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, x: -12 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.4, delay: 0.1 * i }}
                className="flex items-start gap-4 py-4 sm:py-5"
              >
                <div className="shrink-0 w-10 h-10 rounded-md bg-[#1F3A5F]/5 text-[#1F3A5F] flex items-center justify-center">
                  {item.icon}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-baseline gap-2 flex-wrap">
                    <h3 className="text-[#1F3A5F] font-semibold text-base sm:text-lg">
                      {item.title}
                    </h3>
                    <span className="flex-1 min-w-[16px] border-b border-dotted border-[#1F3A5F]/25 hidden sm:block" />
                    <span
                      className="text-[10px] sm:text-xs tracking-[0.2em] text-[#C9502F] font-semibold"
                      style={{ fontFamily: TICKET.mono }}
                    >
                      {item.status}
                    </span>
                  </div>
                  <p className="text-sm sm:text-base text-[#1F3A5F]/60 mt-1 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          {/* CTA — stamp button */}
          <div className="flex flex-col items-center text-center pt-2">
            <motion.button
              whileHover={{ scale: 1.03, rotate: 0 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => navigate('/signup')}
              className="group relative -rotate-1 inline-flex items-center justify-center gap-3 w-full sm:w-auto bg-[#C9502F] hover:bg-[#B4441F] text-[#FBF8F1] font-semibold text-base sm:text-lg px-8 sm:px-10 py-4 sm:py-5 rounded-md border-2 border-[#8f3216] shadow-[0_10px_0_0_#8f3216] active:shadow-[0_4px_0_0_#8f3216] active:translate-y-1.5 transition-all duration-150 uppercase tracking-wider"
              style={{ fontFamily: TICKET.mono }}
            >
              Register as a job seeker
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </motion.button>

            <p className="mt-6 text-sm text-[#1F3A5F]/60">
              Already have an account?{' '}
              <button
                onClick={() => navigate('/signin')}
                className="text-[#C9502F] font-medium underline underline-offset-4 hover:text-[#B4441F]"
              >
                Sign in
              </button>
            </p>
          </div>
        </div>

        {/* Ticket footer stub */}
        <div
          className="text-center mt-4 text-[10px] sm:text-xs tracking-[0.2em] uppercase text-[#1F3A5F]/40"
          style={{ fontFamily: TICKET.mono }}
        >
          Nigeria &middot; Skilled trades, verified
        </div>
      </motion.div>
    </div>
  );
};

export default RegisterAsJobSeeker;